export enum TrackingEvent {
  Add = `[Annotations] Add Annotation`,
  Edit = `[Annotations] Edit Annotation`,
  Delete = `[Annotations] Delete Annotation`,
  Read = `[Annotations] Read Annotation`,
}

export enum TrackingEventProperty {
  ReportName = `Report name`,
  AnnotationTimestamp = `Annotation Timestamp`,
  AnnotationText = `Annotation Text`,
  AnnotationCount = `# of annotations`,
}

type TrackingEventProperties = {
  [key in TrackingEventProperty]?: any;
};

export function track(event: TrackingEvent, properties: TrackingEventProperties) {
  mixpanel.track(event, properties);
}
